// extracted by mini-css-extract-plugin
export default {"loading":"loader_loading__obK0I","loading_with_bg":"loader_loading_with_bg__PC7SJ","loaderAnimation":"loader_loaderAnimation__6bRYP"};